import React, { Component } from "react";
import AppContent from "../body/AppContent";
import LeftNav from "../body/LeftNav";
import "./app.css";
import { Icon } from "antd";
import { getUser, hideLeftNav } from "../../helpers";

export default class AppBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navbarCollapsed: false
    };
  }
  handleNavbarCollapse = e => {
    if (e) e.preventDefault();
    this.setState({ navbarCollapsed: !this.state.navbarCollapsed });
  };
  render() {
    const { navbarCollapsed } = this.state;
    let currentPage = null;
    const pathName = window.location.pathname;
    // highlight navigation on pageload
    // find number of occurences of /
    const pathStr = (pathName.match(new RegExp("/", "g")) || []).length;

    if (pathStr === 1) {
      currentPage = pathName.replace("/", "");
    } else if (pathStr === 2) {
      currentPage = pathName.substring(1).split("/")[0];
    } else if (pathStr === 3) {
      currentPage = pathName
        .substring(1, pathName.lastIndexOf("/"))
        .split("/")[0];
    } else {
      currentPage = pathName
        .substring(1, pathName.lastIndexOf("/"))
        .split("/")[0];
    }

    return (
      <div>
        <a
          href="#"
          onClick={this.handleNavbarCollapse}
          className="drawer-toggler"
        >
          <Icon type={navbarCollapsed ? "menu-fold" : "menu-unfold"} />
        </a>
        {getUser() && !hideLeftNav() && (
          <LeftNav
            currentPage={currentPage}
            collapsed={navbarCollapsed}
            handleNavbarCollapse={this.handleNavbarCollapse}
          />
        )}
        <AppContent />
      </div>
    );
  }
}
